<template>
    <a-modal
        title="跟进信息"
        :visible="visible"
        :confirm-loading="submitting"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="900"
    >
        <a-row :gutter="24">
            <a-col :span="12">
                <a-form-model :model="form">
                    <a-form-model-item label="本次跟进内容">
                        <a-input type="textarea" v-model="form.content" />
                    </a-form-model-item>
                </a-form-model>
            </a-col>
            <a-col :span="12"></a-col>
        </a-row>
    </a-modal>
</template>
<script>
export default {
    props: {
        visible: false,
        mode: {
            default: "create"
        },
        callback: null
    },
    data() {
        return {
            form: {
                name: null,
                content: null
            },
            submitting: false
        };
    },
    methods: {
        on_ok() {
            this.submitting = true;
        },
        on_cancel() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="less" scoped>
</style>
